(() => {
  const formSelector = '[data-testid="klaviyo-form-U5BEAd"]';
  let scheduledFrame = 0;

  function replaceExtraHeadings(form) {
    form.querySelectorAll('h1').forEach((heading) => {
      const replacement = document.createElement('h2');
      for (const attribute of heading.attributes) {
        replacement.setAttribute(attribute.name, attribute.value);
      }
      while (heading.firstChild) {
        replacement.appendChild(heading.firstChild);
      }
      heading.replaceWith(replacement);
    });
  }

  function skipPhoneStep(form) {
    const phoneField = form.querySelector(
      'input[type="tel"], input[autocomplete="tel"], [data-testid*="phone"] input'
    );
    if (!phoneField) return;

    const skipButton = Array.from(form.querySelectorAll('button, [role="button"]')).find(
      (button) => button.textContent.trim() === 'Skip, email is enough'
    );

    if (!skipButton || skipButton.offsetParent === null || skipButton.dataset.dfAutoSkipped === 'true') {
      return;
    }

    skipButton.dataset.dfAutoSkipped = 'true';
    window.setTimeout(() => skipButton.click(), 0);
  }

  function normalizeCopy(form) {
    const replacements = new Map([
      [
        'Free shipping, 30 day money back, and a fourth shirt free when you buy three.',
        'Free shipping, Buy 3 Get 1 Free, and 30-Day Refunds. Shop with confidence.'
      ],
      ['No thanks, full price is fine', "No thanks, I'll pay full price"]
    ]);

    form.querySelectorAll('*').forEach((element) => {
      if (element.children.length !== 0) return;
      let text = element.textContent.trim();
      replacements.forEach((replacement, original) => {
        if (text.includes(original)) {
          text = text.replace(original, replacement);
        }
      });
      if (text !== element.textContent.trim()) {
        element.textContent = text;
      }
    });

    form.querySelectorAll('img[alt]').forEach((image) => {
      const nextAlt = image.alt.replace(/complicated pattern/gi, 'patterned');
      if (nextAlt !== image.alt) image.alt = nextAlt;
    });
  }

  function processForm() {
    const form = document.querySelector(formSelector);
    if (!form) return;
    replaceExtraHeadings(form);
    normalizeCopy(form);
    skipPhoneStep(form);
  }

  function scheduleProcess(records) {
    if (records && !records.some((record) => {
      const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
      if (target && target.closest(formSelector)) return true;
      return Array.from(record.addedNodes).some((node) =>
        node.nodeType === 1 && (node.matches(formSelector) || node.querySelector(formSelector))
      );
    })) return;
    if (scheduledFrame) return;
    scheduledFrame = window.requestAnimationFrame(() => {
      scheduledFrame = 0;
      processForm();
    });
  }

  const observer = new MutationObserver(scheduleProcess);

  function start() {
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['alt'],
      childList: true,
      subtree: true
    });
    scheduleProcess();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener(
    'click',
    (event) => {
      const button = event.target.closest('button, [role="button"]');
      if (!button || !button.closest(formSelector)) return;
      if (button.textContent.trim() !== 'Start shopping') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign('/collections/shop-all');
    },
    true
  );
})();
